// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ge-1";
export var quotedThread = "_ge-0";